import { forwardRef } from 'react'
import { IconProps } from '../Types'
import { filterDOMProps } from '@react-aria/utils'

export const FacebookBrand = forwardRef<SVGSVGElement, IconProps>(({ size = 35, color, ...rest }, forwardedRef) => {
  const domProps = filterDOMProps(rest, { labelable: true, propNames: new Set(['role']) })
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size + 1}
      height={size}
      viewBox="0 0 36 35"
      fill="none"
      ref={forwardedRef}
      {...domProps}
    >
      <path
        d="M35.6666 17.4986C35.6661 14.1541 34.7074 10.8798 32.9039 8.06333C31.1005 5.24684 28.5278 3.00612 25.4906 1.60642C22.4533 0.206723 19.0786 -0.293329 15.766 0.165464C12.4534 0.624256 9.34159 2.02268 6.799 4.19518C4.2564 6.36768 2.38949 9.22328 1.41928 12.4239C0.449064 15.6245 0.416177 19.0362 1.32451 22.2549C2.23285 25.4737 4.04436 28.3647 6.5446 30.5859C9.04484 32.807 12.1291 34.2651 15.4323 34.7877V22.5587H10.9894V17.4986H15.4323V13.6439C15.4323 9.25546 18.0441 6.83371 22.0429 6.83371C23.9569 6.83371 25.9585 7.17499 25.9585 7.17499V11.4825H23.7535C21.5791 11.4825 20.901 12.8323 20.901 14.2171V17.4986H25.7551L24.9785 22.5587H20.901V34.7877C25.0173 34.1356 28.7658 32.0361 31.4725 28.8668C34.1792 25.6976 35.6664 21.6665 35.6666 17.4986Z"
        fill="#1877F2"
      />
      <path
        d="M25.7549 17.4989H20.9009V14.2174C20.9009 12.8326 21.579 11.4828 23.7534 11.4828H25.9584V7.17526C25.9584 7.17526 23.9568 6.83398 22.0428 6.83398C18.044 6.83398 15.4321 9.25792 15.4321 13.6442V17.4989H10.9893V22.5589H15.4321V34.788C16.3367 34.9296 17.2509 35.0006 18.1665 35.0002C19.0821 35.0006 19.9963 34.9296 20.9009 34.788V22.5589H24.9784"
        fill="white"
      />
    </svg>
  )
})
